module.exports = __webpack_public_path__ + "img/RoyalVet.91ead965.png";